<template>
	<el-dialog :visible.sync="is_visible" :width="'40%'" @close="close" :modal="false">
		<template slot="title">
			<div>
				<h3 class="mb-0 font-weight-500">{{ is_update ? 'Update Remark' : 'Add Remark' }}</h3>
			</div>
		</template>
		<b-form role="form">
			<b-row>
				<b-col cols="12">
					<b-form-group label="Remarks">
						<b-form-textarea v-model="form.content" placeholder="Write remarks here"></b-form-textarea>
					</b-form-group>
				</b-col>
				<b-col cols="12" class="text-center">
					<el-button class="bg-primary text-white w-100" @click.prevent="submit()" :loading="is_loading_btn">Save</el-button>
				</b-col>
			</b-row>
		</b-form>
	</el-dialog>
</template>
<script>
import { Button, Dialog } from 'element-ui'
import CurrencyInput from '@/components/CurrencyInput'
import { swal } from '@/assets/js/httpImports.js';
import { mapState, mapActions } from 'pinia';
import { useLoanCaseStore } from '@/stores/loanCaseStore';

export default {
	// props: ['editData'],
	components: {
		CurrencyInput,
		[Button.name]: Button,
		[Dialog.name]: Dialog,
	},
	data() {
		return {
			is_visible: false,
			is_update: false,
			is_loading_btn: false,
			form: {
				content:''
			}
		}
	},
	computed: {
	},
	created() {
	},
	methods: {
		...mapActions(useLoanCaseStore, ['createRemark', 'updateRemark', 'getCase']),
		show(editData=null){
			if (!_gHlp.isEmpty(editData)) {
				this.setForm(editData);
			}
			this.is_loading_btn = false
			this.is_visible = true
		},
		close() {
			this.clean();
			this.is_loading_btn = false
			this.is_visible = false
		},
		clean() {
			this.form = {
				content: '',
			}
			this.is_update = false
		},
		setForm(editData) {
			// this.clean();
			this.is_update = true;
			this.form = editData;
		},
		submit() {
			this.is_loading_btn = true;
			const params = {
				...this.form
			};
			if (this.form.rmrk_id) {
				this.updateRemark(this.form.rmrk_id, params).then((resp) => {
					this.$emit('closeModal',true);
					_gNotif.notifySuccess('<b>Remark</b> - Successfully Updated.')
					this.is_loading_btn = false;
					this.is_visible = false
				});
			} else {
				this.createRemark(params).then((resp) => {
					this.$emit('closeModal',true);
					_gNotif.notifySuccess('<b>Remark</b> - Successfully Created.')
					this.is_loading_btn = false;
					this.is_visible = false
				});
			}
		}
	}
}
</script>